import { Action, createReducer, on } from '@ngrx/store';
import { WelcomeActions } from '.';
import { ListDashboardDto } from '../../../services/api.services';

export type WelcomeDashboard = ListDashboardDto & {

};

export interface State {
  visible: boolean;

  loadingDashboards: boolean;
  dashboards: WelcomeDashboard[];

  displayedDashboards: WelcomeDashboard[];

  selectedDashboardId: number;
}

export const initialState: State = {
  visible: false,

  loadingDashboards: false,
  dashboards: [],

  displayedDashboards: [],

  selectedDashboardId: 0
};

const welcomeReducer = createReducer(
  initialState,

  on(WelcomeActions.setVisible, (state, { visible }) => {
    return {
      ...state,
      visible
    };
  }),

  on(WelcomeActions.loadDashboards, (state) => {
    return {
      ...state,
      loadingDashboards: true
    };
  }),

  on(WelcomeActions.loadDashboardsSuccess, (state, { dashboards }) => {
    return {
      ...state,
      loadingDashboards: false,
      dashboards,
      displayedDashboards: dashboards.filter(d => d.fromLibrary).slice(0, 6)
    };
  }),

  on(WelcomeActions.loadDashboardsFailure, (state) => {
    return {
      ...state,
      loadingDashboards: false
    };
  }),


  on(WelcomeActions.setSelectedDashboard, (state, { dashboardId }) => {
    return {
      ...state,
      selectedDashboardId: dashboardId
    };
  }),
);

export function reducer(state: State | undefined, action: Action) {
  return welcomeReducer(state, action);
}
